import React, { useContext } from "react";
import { loginContext } from "./Login";
import { REACT_APP_DB_NAME } from "../env";
import { PasswordLogin } from "../components/PasswordLogin";
import { BankIdLogin } from "../components/BankIdLogin";
import { useBankIdAuth } from "../hooks/useBankIdAuth";

export const LoginScreen = (): React.ReactElement => {
    const { login, setLogin } = useContext(loginContext);

    const handleLoginSuccess = (loginData: any) => {
        setLogin({
            ...login,
            ...loginData
        });
    };

    const handleToggleMode = () => {
        const usePassword = REACT_APP_DB_NAME === "prod" ? !login.usePassword : true;
        setLogin({ ...login, usePassword, statusMessage: "", errorMessage: "" });
    };

    const { bankIdData, restartBankIdAuth, openBankIdApp } = useBankIdAuth({
        loggedIn: login.loggedIn,
        usePassword: login.usePassword,
        onLoginSuccess: handleLoginSuccess
    });

    if (login.token) return null;

    if (login.usePassword || REACT_APP_DB_NAME === "test") {
        return <PasswordLogin onSubmit={handleLoginSuccess} onToggleMode={handleToggleMode} />;
    }

    return (
        <BankIdLogin
            bankIdData={bankIdData}
            onRestart={restartBankIdAuth}
            onToggleMode={handleToggleMode}
            onOpenBankIdApp={openBankIdApp}
        />
    );
};
